export const loadFromDOM = (elementId: string) => {
  const initialJson = document.querySelector<HTMLScriptElement>(elementId);
  if (initialJson) {
    try {
      return JSON.parse(initialJson.innerHTML);
    } catch {
      console.error('failed to load $elementId from DOM');
    }
  } else {
    console.error('failed to load $elementId from DOM');
  }
};
